import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  ApiPaginationResult,
  ApiResult,
} from '../../shared/models/api-result.model';
import {
  CreatePaymentFrequence,
  UpdatePaymentFrequence,
} from '../models/payment-frequency.model';

@Injectable({
  providedIn: 'root',
})
export class PaymentFrequencyService {
  private http = inject(HttpClient);

  apiBaseUrl = environment.apiBaseUrl;

  getAll(
    pageNumber: number,
    pageSize: number,
    name?: string,
    description?: string
  ) {
    let params = '';

    if (name) params += `&name=${name}`;
    if (description) params += `&description=${description}`;

    return this.http.get<ApiPaginationResult>(
      this.apiBaseUrl +
        `/api/v1/payment-frequencies?pageNumber=${pageNumber}&pageSize=${pageSize}${params}`
    );
  }

  getById(id: string) {
    return this.http.get<ApiResult>(
      this.apiBaseUrl + '/api/v1/payment-frequencies/' + id
    );
  }

  getAllDropdown() {
    return this.http.get<ApiResult>(
      this.apiBaseUrl + `/api/v1/payment-frequencies/dropdown`
    );
  }

  create(data: CreatePaymentFrequence) {
    return this.http.post<ApiResult>(
      this.apiBaseUrl + '/api/v1/payment-frequencies',
      data
    );
  }

  update(id: string, data: UpdatePaymentFrequence) {
    return this.http.put<ApiResult>(
      this.apiBaseUrl + '/api/v1/payment-frequencies/' + id,
      data
    );
  }

  updateStatus(id: string, isActive: boolean) {
    return this.http.patch<ApiResult>(
      this.apiBaseUrl + `/api/v1/payment-frequencies/${id}/status`,
      { isActive }
    );
  }
}
